module.exports = __webpack_public_path__ + "fonts/Gilroy-SemiBold.a5cf732b.ttf";